// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__oPzXI","amount":"Amount_amount__HptN2","tip":"Amount_tip__1Z7G7","tipHeader":"Amount_tipHeader__1RzHQ","tipsWrap":"Amount_tipsWrap__2GWCh"};